"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileElement = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const slate_react_1 = require("slate-react");
const context_1 = require("../../../context");
const BrokenFileCard_1 = require("./BrokenFileCard");
const ResolvedFileCard_1 = require("./ResolvedFileCard");
const FileElement = ({ attributes, children, element }) => {
    const mutxt = (0, context_1.useMuTxt)();
    mutxt.things.version.use();
    const isSelected = (0, slate_react_1.useSelected)();
    const isFocused = (0, slate_react_1.useFocused)();
    const selected = isSelected && isFocused;
    const thingId = element['@thing'];
    const thing = thingId ? mutxt.things.get(thingId) : undefined;
    return (React.createElement("div", { ...attributes },
        React.createElement("div", { contentEditable: false }, thing ? (React.createElement(ResolvedFileCard_1.ResolvedFileCard, { thing: thing, selected: selected, element: element })) : (React.createElement(BrokenFileCard_1.BrokenFileCard, { thingId: thingId, selected: selected }))),
        children));
};
exports.FileElement = FileElement;
